import { FormatQuoteRounded, NumbersRounded } from '@mui/icons-material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import {
  Chip,
  Grid,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { LabelType } from 'generated/graphql';

interface Label {
  id: string;
  displayName: string;
  type: LabelType;
}

interface LabelRecommendationsProps {
  title: string;
  infoText: string;
  labels: Label[];
  onSelect: (label: Label) => void;
  isLoading: boolean;
  hideTooltip?: boolean;
}

export function LabelRecommendations({
  title,
  infoText,
  labels = [],
  onSelect,
  isLoading,
  hideTooltip,
}: LabelRecommendationsProps) {
  if (isLoading) {
    return (
      <Stack width="100%">
        <Skeleton animation="wave" width="50%" />
        <Skeleton animation="wave" variant="rectangular" height={118} />
      </Stack>
    );
  }

  if (!labels.length) {
    return null;
  }

  const avatar =
    labels[0].type === LabelType.Aspect ? (
      <NumbersRounded />
    ) : (
      <FormatQuoteRounded />
    );

  const renderChip = (label: Label) => {
    return (
      <Chip
        label={label.displayName}
        variant="outlined"
        icon={avatar}
        color="primary"
        sx={{ maxWidth: 400 }}
        onClick={() => onSelect(label)}
      ></Chip>
    );
  };

  return (
    <Stack direction="column" minWidth="33%">
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography variant="subtitle2" color="text.secondary">
          {avatar} {title}
        </Typography>
        <Tooltip title={infoText}>
          <InfoOutlined fontSize="small" sx={{ color: 'text.secondary' }} />
        </Tooltip>
      </Stack>
      <Grid container spacing={1.5} mt={0}>
        {labels.map((label) => {
          return (
            <Grid item key={label.id}>
              {hideTooltip ? (
                renderChip(label)
              ) : (
                <Tooltip
                  title={label.displayName}
                  placement="top"
                  disableInteractive
                >
                  {renderChip(label)}
                </Tooltip>
              )}
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
}
